import { colors } from '@chegg-ui/theme'
import { ScreenSize, DESKTOP, LAPTOP } from '@chegg-wt/core/hooks/useScreenSize'

import { baseStepProps } from '../../Tour/utils'
import { TourStep, TourPlacement } from '../../Tour/types'
import { UploadWidgetContainerId } from '../domIds'
import {
  CreateCitationPanelId,
  ExpertCheckContainerPanelId,
} from '../../FeaturePanel/domIds'
import { CitationWidgetId } from '../../CitationWidget/domIds'
import { TourUploadWidget, TourCitation, TourExpertCheck } from './tourComponents'

interface StepPlacement {
  placement: TourPlacement
  arrowColor: string
}

export const tourDashboardSteps = (
  isPro: boolean,
  hasCitationsExperience: boolean,
  currentScreenSize: ScreenSize
): TourStep[] => {
  const isLargeScreen = currentScreenSize === DESKTOP || currentScreenSize === LAPTOP

  const widgetPlacement: StepPlacement = isLargeScreen
    ? {
        placement: 'left-start',
        arrowColor: isPro ? colors.royalXlight : colors.white,
      }
    : { placement: 'bottom', arrowColor: colors.royalXlight }

  const citationPlacement: StepPlacement = isLargeScreen
    ? { placement: 'right-start', arrowColor: colors.royalXlight }
    : { placement: 'bottom', arrowColor: colors.royalXlight }

  const expertCheckPlacement: StepPlacement = isLargeScreen
    ? { placement: 'right', arrowColor: colors.royalXlight }
    : { placement: 'top', arrowColor: colors.white }

  return [
    {
      ...baseStepProps,
      target: `#${UploadWidgetContainerId}`,
      content: TourUploadWidget,
      placement: widgetPlacement.placement,
      floaterProps: {
        disableAnimation: true,
        disableFlip: true,
      },
      styles: {
        ...baseStepProps.styles,
        options: {
          arrowColor: widgetPlacement.arrowColor,
        },
      },
    },
    {
      ...baseStepProps,
      target: hasCitationsExperience
        ? `#${CitationWidgetId}`
        : `#${CreateCitationPanelId}`,
      content: TourCitation,
      placement: citationPlacement.placement,
      floaterProps: {
        disableFlip: true,
      },
      styles: {
        ...baseStepProps.styles,
        options: {
          arrowColor: citationPlacement.arrowColor,
        },
      },
    },
    {
      ...baseStepProps,
      target: `#${ExpertCheckContainerPanelId}`,
      content: TourExpertCheck,
      placement: expertCheckPlacement.placement,
      floaterProps: {
        disableFlip: true,
      },
      styles: {
        ...baseStepProps.styles,
        options: {
          arrowColor: expertCheckPlacement.arrowColor,
        },
      },
    },
  ]
}
